import React, { Component } from 'react';
import debounce from 'lodash.debounce';

import { Container, Row, Col } from './Grid';
import Feedback from './Feedback';
import StructureInput from './StructureInput';
import CandidateInput from './CandidateInput';
import Instructions from './Instructions';
import codeCheck from './codeCheck';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 'contain',
      previousType: 'contain',
      structure: '',
      previousStructure: '',
      candidate: '',
      previousCandidate: '',
      feedbackText: null,
      passed: null,
    }

    this.typeOnChange = this.createOnChange('type');
    this.structureOnChange = this.createOnChange('structure');
    this.candidateOnChange = this.createOnChange('candidate');
    this.checkCode = debounce(this.checkCode, 1000);
  }

  isChanged = () =>
    this.state.structure !== this.state.previousStructure
    || this.state.candidate !== this.state.previousCandidate
    || this.state.type !== this.state.previousType;

  checkCode = () => {
    if (this.isChanged()) {
      const { passed, feedback: feedbackText } = codeCheck[this.state.type](
        this.state.structure, this.state.candidate);
      this.setState((state) => ({
        ...state,
        passed,
        feedbackText,
        previousType: this.state.type,
        previousStructure: this.state.structure,
        previousCandidate: this.state.candidate,
      }));
    }
  }

  createOnChange = (stateSlice) => (e) => {
    const value = e.target.value;
    if (this.state[stateSlice] !== value) {
      this.setState((state) => {
        return {
          ...state,
          [stateSlice]: value,
        };
      }, () => {
        this.checkCode();
      });
    }
  }

  render() {
    const loading = this.isChanged();
    return (
      <div>
        <Feedback
          feedbackText={this.state.feedbackText}
          passed={this.state.passed}
          loading={loading}
        />
        <Container>
          <Row>
            <Col size={1}>
              <StructureInput
                typeOnChange={this.typeOnChange}
                typeVal={this.state.type}
                structureOnChange={this.structureOnChange}
                structureVal={this.state.structure}
              />
            </Col>
            <Col size={1}>
              <CandidateInput
                candidateOnChange={this.candidateOnChange}
                candidateVal={this.state.candidate}
              />
            </Col>
          </Row>
          <Instructions />
        </Container>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js